module.exports = __webpack_public_path__ + "img/enUS_add_to_google_wallet_wallet-button.942f8983.svg";